/**
 * 须在 main.ts 最前 import，保证 localStorage 默认语言在其它模块读取前已写入。
 */
import { applySkillhubStartupState } from './utils/skillhubStartupState'

applySkillhubStartupState()
